module.exports = __webpack_public_path__ + "static/media/arrow-right.5809d706.svg";